import { createFileRoute } from "@tanstack/react-router";
import { getRingGameRank } from "@/lib/client/ring-game";
import { RingRankPage } from "@/features/game/ring/ring-rank-page";
import z from "zod";

export const Route = createFileRoute("/_index/game/ring-rank")({
  component: RouteComponent,
  validateSearch: z.object({
    period: z.enum(["month", "all"]).optional().catch("month").default("month"),
  }),
  loaderDeps: (opts) => opts.search,
  loader: async ({ deps }) => {
    const rank = await getRingGameRank({ period: deps.period });
    return { rank };
  },
});

function RouteComponent() {
  const { rank } = Route.useLoaderData() as { rank: Awaited<ReturnType<typeof getRingGameRank>> };
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const period = search.period;

  return (
    <RingRankPage
      rank={rank}
      period={period}
      onPeriodChange={(nextPeriod) =>
        navigate({
          search: () => ({ period: nextPeriod }),
          replace: true,
        })
      }
    />
  );
}
